export default "__VITE_ASSET__8dkoVcoY__"